export default __webpack_public_path__ + "static/media/pushNotification.e7a63629.png";